import React from 'react';
import { observer } from 'mobx-react';
import { measureText, getContainingView, getContainingTrack, } from '@jbrowse/core/util';
import { getConf } from '@jbrowse/core/configuration';
import { BaseLinearDisplayComponent, } from '@jbrowse/plugin-linear-genome-view';
import YScaleBar from '../../shared/YScaleBar';
const LinearWiggleDisplay = observer((props) => {
    const { model } = props;
    const { stats, height, needsScalebar } = model;
    const { trackLabels } = getContainingView(model);
    const track = getContainingTrack(model);
    const left = trackLabels === 'overlapping'
        ? measureText(getConf(track, 'name'), 12.8) + 100
        : 50;
    return (React.createElement("div", null,
        React.createElement(BaseLinearDisplayComponent, { ...props }),
        stats && needsScalebar ? (React.createElement("svg", { style: {
                position: 'absolute',
                top: 0,
                left,
                pointerEvents: 'none',
                height,
                width: 50,
            } },
            React.createElement(YScaleBar, { model: model }))) : null));
});
export default LinearWiggleDisplay;
